import { Modal, Button, TextInput, Select } from '@mantine/core';


const AddLicenseModal = ({
  open,
  onClose,
  formData,
  handleInputChange,
  handleAddLicense,
  handleRippleEffect,
  isEditing,
  userType, // still needed for company field
  type,
  setType,
  licenceType
}) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#F7F7F7',
          padding: '20px 30px',
          borderRadius: '8px',
          width: '100vw',
          maxWidth: '100%', // smaller max width looks better for forms
          position: 'relative',
          maxHeight: '100vh', // ✅ remove responsive object
          overflowY: 'auto', // ✅ remove responsive object
        }}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h1
            style={{
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '24px',
              fontWeight: 700,
              color: '#202224',
            }}
          >
            {isEditing ? 'Edit License' : 'Add License'}
          </h1>

        </div>

        {/* License Information Section */}
        <h2
          style={{
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '1.25rem',
            fontWeight: 700,
            color: '#202224',
            marginBottom: '12px',
          }}
        >
          License Information
        </h2>
        <div className="mb-4">
          {/* User Type */}
          <div className="flex flex-col flex-1">
            <label
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: { xs: '10px', sm: '12px' },
                fontWeight: 600,
                color: '#202224',
                marginBottom: '6px',
              }}
            >
              Type*
            </label>
            <Select
              value={type}
              onChange={(value) => {
                setType(value);
                

                // ✅ If single_device, set devices to 1 automatically
                if (value === 'single_device') {
                  handleInputChange('no_of_devices', 1);
                }
              }}
              data={licenceType}
              placeholder="Select  Type"
              styles={{
                input: {
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: { xs: '10px', sm: '12px' },
                  color: '#595C60',
                  backgroundColor: '#FCFCFC',
                  border: '0.6px solid #595C60',
                  borderRadius: '6px',
                  width: '100%',
                  maxWidth: { xs: '100%', sm: '200px' },
                  height: { xs: '36px', sm: '40px' },
                  '&:focus': {
                    borderColor: '#FF6B00',
                    outline: 'none',
                  },
                },
                item: {
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: { xs: '10px', sm: '12px' },
                  color: '#595C60',
                  '&[data-selected]': {
                    backgroundColor: '#FF6B00',
                    color: '#FFFFFF',
                    '&:hover': {
                      backgroundColor: '#FF6B00',
                      color: '#FFFFFF',
                    },
                  },
                  '&:hover': {
                    backgroundColor: '#FFF3E5',
                  },
                },
              }}
            />
          </div>
          {/* Expiry */}
          <div className="flex flex-col mb-3">
            <label className="font-semibold mb-2">Expiry*</label>
            <TextInput
              type="date"
              value={formData.expiry_date}
              onChange={(e) => handleInputChange('expiry_date', e.target.value)}
            />
          </div>

          {/* Row with Devices & Deletions */}
          <div className="flex flex-row gap-3 mb-3">
            {/* No. of Devices */}
            <div className="flex flex-col flex-1">
              <label className="font-semibold mb-2">No. of Devices*</label>
              <TextInput
                type="number"
                value={type === 'single_device' ? 1 : formData.no_of_devices}
                onChange={(e) => handleInputChange('no_of_devices', e.target.value)}
                disabled={type === 'single_device'} // ✅ make uneditable
              />
            </div>

            {/* No. of Deletions */}
            <div className="flex flex-col flex-1">
              <label className="font-semibold mb-2">No. of Deletions*</label>
              <TextInput
                type="number"
                value={formData.no_of_deletions}
                onChange={(e) => handleInputChange('no_of_deletions', e.target.value)}
              />
            </div>
          </div>


        </div>

        {/* Add/Edit License Button */}
        <div className="flex justify-end">
          <Button
            className="export-button"
            styles={{
              root: {
                width: '140px',
                height: '36px',
                backgroundColor: '#FF7A00',
                borderRadius: '20px',
              },
              label: {
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                color: '#fff',
              },
            }}
            onClick={(e) => {
              handleRippleEffect(e);
              handleAddLicense();
            }}
            disabled={
              !formData.expiry_date ||
              !formData.no_of_deletions}
          >
            {isEditing ? 'Update License' : 'Add License'}
          </Button>
        </div>
      </div>

    </Modal>
  );
};

export default AddLicenseModal;
